import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Invoice\InvoiceExportController::__invoke
* @see app/Http/Controllers/Invoice/InvoiceExportController.php
* @route '/api/invoice/export-excel'
*/
const InvoiceExportController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: InvoiceExportController.url(options),
    method: 'post',
})

InvoiceExportController.definition = {
    methods: ["post"],
    url: '/api/invoice/export-excel',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Invoice\InvoiceExportController::__invoke
* @see app/Http/Controllers/Invoice/InvoiceExportController.php
* @route '/api/invoice/export-excel'
*/
InvoiceExportController.url = (options?: RouteQueryOptions) => {
    return InvoiceExportController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Invoice\InvoiceExportController::__invoke
* @see app/Http/Controllers/Invoice/InvoiceExportController.php
* @route '/api/invoice/export-excel'
*/
InvoiceExportController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: InvoiceExportController.url(options),
    method: 'post',
})

export default InvoiceExportController